// hooks/useViewport.js

import { useState, useEffect } from 'react';

/**
 * A hook that provides the current viewport width and a boolean indicating
 * whether the user is currently using a mobile device (i.e. the viewport
 * width is less than 768px).
 *
 * @returns {Object} An object with two properties: `width` and `isMobile`.
 * `width` is the current width of the viewport in pixels.
 * `isMobile` is a boolean indicating whether the user is currently using a
 * mobile device.
 *
 * @example
 * const { width, isMobile } = useViewport();
 */
const useViewport = () => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return { isMobile: width < 768, width };
};

export default useViewport;
